document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-maati-home-buy-now]');
  if (!button || button.disabled) return;

  const form = button.closest('[data-maati-home-buy-now-form]');
  if (!form) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const returnToInput = form.querySelector('input[name="return_to"]') || document.createElement('input');
  returnToInput.type = 'hidden';
  returnToInput.name = 'return_to';
  returnToInput.value = '/checkout';
  if (!returnToInput.parentElement) form.append(returnToInput);

  const submitterInput = form.querySelector('input[name="add"][data-maati-home-buy-now-submit]') || document.createElement('input');
  submitterInput.type = 'hidden';
  submitterInput.name = 'add';
  submitterInput.value = '';
  submitterInput.setAttribute('data-maati-home-buy-now-submit', '');
  if (!submitterInput.parentElement) form.append(submitterInput);

  HTMLFormElement.prototype.submit.call(form);
});
